<template>
    <div class="report">
        <div class="report_item">
            <div class="title">
                — — — 稳定/物理性 — — —
            </div>
            <div class="content">
                <div class="content_item" v-if="getTestShow('p1-1')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            {{currentGoods.yarnType === '梭织布' ? '30℃' : '41℃'}}水洗 | 1次
                        </div>
                        <div class="standard">
                            测试标准：{{currentGoods.yarnType === '梭织布' ? 'AATCC 135 1, III, A(ii)' : 'AATCC 135 1, III, B'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                经：
                            </div>
                            <div class="value">
                                {{testMsg.warp1stWash || '-'}}
                            </div>
                            <div class="label">
                                &nbsp;%
                            </div>
                        </div>
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                纬：
                            </div>
                            <div class="value">
                                {{testMsg.weft1stWash || '-'}}
                            </div>
                            <div class="label">
                                &nbsp;%
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p1-2')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            {{currentGoods.yarnType === '梭织布' ? '30℃' : '41℃'}}水洗 | 3次
                        </div>
                        <div class="standard">
                            测试标准：{{currentGoods.yarnType === '梭织布' ? 'AATCC 135 1, III, A(ii)' : 'AATCC 135 1, III, B'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                经：
                            </div>
                            <div class="value">
                                {{testMsg.warp3rdWash || '-'}}
                            </div>
                            <div class="label">
                                &nbsp;%
                            </div>
                        </div>
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                纬：
                            </div>
                            <div class="value">
                                {{testMsg.weft3rdWash || '-'}}
                            </div>
                            <div class="label">
                                &nbsp;%
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p1-3')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            热熔收缩
                        </div>
                        <div class="standard">
                            测试标准：1min @150°C
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                经：
                            </div>
                            <div class="value">
                                {{testMsg.warp150C || '-'}}
                            </div>
                            <div class="label">
                                &nbsp;%
                            </div>
                        </div>
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                纬：
                            </div>
                            <div class="value">
                                {{testMsg.weft150C || '-'}}
                            </div>
                            <div class="label">
                                &nbsp;%
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p1-4')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            克重
                        </div>
                        <div class="standard">
                            测试标准：{{testMsg.weightStandard || '-'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 100%">
                            <div class="value">
                                {{testMsg.weightGM || '-'}}
                            </div>
                            <div class="label">
                                &nbsp;G/M²
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p1-5')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            幅宽
                        </div>
                        <div class="standard">
                            测试标准：{{testMsg.widthStandard || '-'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                Cuttable：
                            </div>
                            <div class="value">
                                {{testMsg.widthCuttable || '-'}}
                            </div>
                            <div class="label">
                                &nbsp;cm
                            </div>
                        </div>
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                Full：
                            </div>
                            <div class="value">
                                {{testMsg.widthFull || '-'}}
                            </div>
                            <div class="label">
                                &nbsp;cm
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p1-6')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            纬斜/弓纬
                        </div>
                        <div class="standard">
                            测试标准：{{testMsg.sbStandard || '-'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                Skew：
                            </div>
                            <div class="value">
                                {{testMsg.skew || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                Bowing：
                            </div>
                            <div class="value">
                                {{testMsg.bowing || '-'}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p1-7')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            摩擦
                        </div>
                        <div class="standard">
                            测试标准：{{testMsg.crockingStandard || '-'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                干摩：
                            </div>
                            <div class="value">
                                {{testMsg.crockingDry || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                湿摩：
                            </div>
                            <div class="value">
                                {{testMsg.crockingWet || '-'}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p1-8')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            Stretch 伸长率 %
                        </div>
                        <div class="standard">
                            测试标准：{{currentGoods.yarnType === '梭织布' ? 'ASTM D3107 (4lb)' : 'ASTM D2594 (5lb)'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                {{currentGoods.yarnType === '梭织布' ? 'Warp' : 'Wales'}}：
                            </div>
                            <div class="value">
                                {{(currentGoods.yarnType === '梭织布' ? testMsg.stretchWarp : testMsg.stretchWales) || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                {{currentGoods.yarnType === '梭织布' ? 'Weft' : 'Courses'}}：
                            </div>
                            <div class="value">
                                {{(currentGoods.yarnType === '梭织布' ? testMsg.stretchWeft : testMsg.stretchCourses) || '-'}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p1-9')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            {{currentGoods.yarnType === '梭织布' ? 'Growth 增长率 %' : 'Growth% After 1 HR'}}
                        </div>
                        <div class="standard">
                            测试标准：{{currentGoods.yarnType === '梭织布' ? 'ASTM D3107 (4lb)' : 'ASTM D2594 (5lb)'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                {{currentGoods.yarnType === '梭织布' ? 'Warp' : 'Wales'}}：
                            </div>
                            <div class="value">
                                {{(currentGoods.yarnType === '梭织布' ? testMsg.growthWarp : testMsg.growthWales) || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                {{currentGoods.yarnType === '梭织布' ? 'Weft' : 'Courses'}}：
                            </div>
                            <div class="value">
                                {{(currentGoods.yarnType === '梭织布' ? testMsg.growthWeft : testMsg.growthCourses) || '-'}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p1-10')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            {{currentGoods.yarnType === '梭织布' ? 'Recovery 回复率 %' : 'Recovery% After 1 HR'}}
                        </div>
                        <div class="standard">
                            测试标准：{{currentGoods.yarnType === '梭织布' ? 'ASTM D3107 (4lb)' : 'ASTM D2594 (5lb)'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                {{currentGoods.yarnType === '梭织布' ? 'Warp' : 'Wales'}}：
                            </div>
                            <div class="value">
                                {{(currentGoods.yarnType === '梭织布' ? testMsg.recoveryWarp : testMsg.recoveryWales) || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                {{currentGoods.yarnType === '梭织布' ? 'Weft' : 'Courses'}}：
                            </div>
                            <div class="value">
                                {{(currentGoods.yarnType === '梭织布' ? testMsg.recoveryWeft : testMsg.recoveryCourses) || '-'}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="report_item">
            <div class="title">
                — — — 起球 — — —
            </div>
            <div class="content">
                <div class="content_item" v-if="getTestShow('p2-1')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            圆轨迹起毛起球
                        </div>
                        <div class="standard">
                            测试标准：GB/T 4802.1
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                10刷50磨：
                            </div>
                            <div class="value">
                                {{testMsg.clp1050 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                600转：
                            </div>
                            <div class="value">
                                {{testMsg.clp600 || '-'}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p2-2')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            马丁代尔起毛起球
                        </div>
                        <div class="standard">
                            测试标准：{{testMsg.mpStandard || '-'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 33%">
                            <div class="value">
                                {{testMsg.mp2000 || '-'}}
                            </div>
                            <div class="label">
                                &nbsp;@2000转
                            </div>
                        </div>
                        <div class="right_item" style="width: 33%">
                            <div class="value">
                                {{testMsg.mp5000 || '-'}}
                            </div>
                            <div class="label">
                                &nbsp;@5000转
                            </div>
                        </div>
                        <div class="right_item" style="width: 33%">
                            <div class="value">
                                {{testMsg.mp7000 || '-'}}
                            </div>
                            <div class="label">
                                &nbsp;@7000转
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p2-3')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            箱式起毛起球
                        </div>
                        <div class="standard">
                            测试标准：{{testMsg.icipStandard || '-'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 33%">
                            <div class="label">
                                2H：
                            </div>
                            <div class="value">
                                {{testMsg.icip2h || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 33%">
                            <div class="label">
                                4H：
                            </div>
                            <div class="value">
                                {{testMsg.icip4h || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 33%">
                            <div class="label">
                                5H：
                            </div>
                            <div class="value">
                                {{testMsg.icip5h || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 33%">
                            <div class="label">
                                10H：
                            </div>
                            <div class="value">
                                {{testMsg.icip10h || '-'}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="report_item">
            <div class="title">
                — — — 色牢度等 — — —
            </div>
            <div class="content">
                <div class="content_item" v-if="getTestShow('p3')">
                    <div class="content_item_left" style="width: 40%">
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 16.6%">
                            <div class="label" style="font-size: 12px;">
                                Ace
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="label" style="font-size: 12px;">
                                Cot
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="label" style="font-size: 12px;">
                                Nyl
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="label" style="font-size: 12px;">
                                Pol
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="label" style="font-size: 12px;">
                                Acr
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="label" style="font-size: 12px;">
                                Wol
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p3-1')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            水洗 | 40°C
                        </div>
                        <div class="standard">
                            测试标准：{{testMsg.launderingStandard || '-'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 100%">
                            <div class="label">
                                Color Change：
                            </div>
                            <div class="value">
                                {{testMsg.colorChange1 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.ace1 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.cot1 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.nyl1 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.pol1 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.acr1 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.wol1 || '-'}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p3-2')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            水洗 | {{testMsg.launderingTemp}}
                        </div>
                        <div class="standard">
                            测试标准：{{testMsg.launderingStandard || '-'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 100%">
                            <div class="label">
                                Color Change：
                            </div>
                            <div class="value">
                                {{testMsg.colorChange2 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.ace2 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.cot2 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.nyl2 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.pol2 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.acr2 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.wol2 || '-'}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p3-3')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            水渍
                        </div>
                        <div class="standard">
                            测试标准：{{testMsg.waterStandard || '-'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 100%">
                            <div class="label">
                                Color Change：
                            </div>
                            <div class="value">
                                {{testMsg.colorChange3 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.ace3 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.cot3 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.nyl3 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.pol3 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.acr3 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.wol3 || '-'}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p3-4')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            汗渍
                        </div>
                        <div class="standard">
                            测试标准：{{testMsg.perspirationStandard || '-'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 100%">
                            <div class="label">
                                Color Change：
                            </div>
                            <div class="value">
                                {{testMsg.colorChange4 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.ace4 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.cot4 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.nyl4 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.pol4 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.acr4 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.wol4 || '-'}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p3-5')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            汗渍
                        </div>
                        <div class="standard">
                            测试标准：{{testMsg.perspirationStandard || '-'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 100%">
                            <div class="label">
                                Color Change：
                            </div>
                            <div class="value">
                                {{testMsg.colorChange5 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.ace5 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.cot5 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.nyl5 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.pol5 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.acr5 || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 16.6%">
                            <div class="value">
                                {{testMsg.wol5 || '-'}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p4-1')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            pH Value
                        </div>
                        <div class="standard">
                            测试标准：{{testMsg.phStandard || '-'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 100">
                            <div class="value">
                                {{testMsg.phValue || '-'}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_item" v-if="getTestShow('p4-2')">
                    <div class="content_item_left" style="width: 40%">
                        <div class="name">
                            Pix 经纬密
                        </div>
                        <div class="standard">
                            测试标准：{{testMsg.pixStandard || '-'}}
                        </div>
                    </div>
                    <div class="content_item_right" style="width: 60%">
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                Warp：
                            </div>
                            <div class="value">
                                {{testMsg.pixWarp || '-'}}
                            </div>
                        </div>
                        <div class="right_item" style="width: 50%">
                            <div class="label">
                                Weft：
                            </div>
                            <div class="value">
                                {{testMsg.pixWeft || '-'}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            currentGoods: { type: Object, default: {} },
            testMsg: { type: Object, default: {} }
        },
        data() {
            return {
            }
        },
        methods: {
            getTestShow(e) {
				let result = false;
				let testMsg = this.testMsg;
				let currentGoods = this.currentGoods;
				switch (e){
					case 'p':
						result = this.getTestShow('p1') || this.getTestShow('p2') || this.getTestShow('p3') || this.getTestShow('p4');
						break;
					case 'p1':
						result = this.getTestShow('p1-1') || this.getTestShow('p1-2') || this.getTestShow('p1-3') || this.getTestShow('p1-4') || this.getTestShow('p1-5') || this.getTestShow('p1-6') || this.getTestShow('p1-7') || this.getTestShow('p1-8') || this.getTestShow('p1-9') || this.getTestShow('p1-10');
						break;
					case 'p1-1':
						result = testMsg.warp1stWash || testMsg.weft1stWash;
						break;
					case 'p1-2':
						result = testMsg.warp3rdWash || testMsg.weft3rdWash;
						break;
					case 'p1-3':
						result = testMsg.warp150C || testMsg.weft150C;
						break;
					case 'p1-4':
						result = testMsg.weightGM && testMsg.weightStandard;
						break;
					case 'p1-5':
						result = (testMsg.widthCuttable || testMsg.widthFull) && testMsg.widthStandard;
						break;
					case 'p1-6':
						result = currentGoods.yarnType === '梭织布' && testMsg.sbStandard && (testMsg.skew || testMsg.bowing);
						break;
					case 'p1-7':
						result = testMsg.crockingStandard && (testMsg.crockingDry || testMsg.crockingWet);
						break;
					case 'p1-8':
						result = currentGoods.yarnType === '梭织布' ? (testMsg.stretchWarp || testMsg.stretchWeft) : (testMsg.stretchWales || testMsg.stretchCourses);
						break;
					case 'p1-9':
						result = currentGoods.yarnType === '梭织布' ? (testMsg.growthWarp || testMsg.growthWeft) : (testMsg.growthWales || testMsg.growthCourses);
						break;
					case 'p1-10':
						result = currentGoods.yarnType === '梭织布' ? (testMsg.recoveryWarp || testMsg.recoveryWeft) : (testMsg.recoveryWales || testMsg.recoveryCourses);
						break;
					case 'p2':
						result = this.getTestShow('p2-1') || this.getTestShow('p2-2') || this.getTestShow('p2-3');
						break;
					case 'p2-1':
						result = testMsg.clp1050 || testMsg.clp600;
						break;
					case 'p2-2':
						result = testMsg.mpStandard && (testMsg.mp2000 || testMsg.mp5000 || testMsg.mp7000);
						break;
					case 'p2-3':
						result = testMsg.icipStandard && (testMsg.icip2h || testMsg.icip4h || testMsg.icip5h || testMsg.icip10h);
						break;
					case 'p3':
						result = this.getTestShow('p3-1') || this.getTestShow('p3-2') || this.getTestShow('p3-3') || this.getTestShow('p3-4') || this.getTestShow('p3-5');
						break;
					case 'p3-1':
						result = testMsg.launderingStandard && (testMsg.colorChange1 || testMsg.ace1 || testMsg.cot1 || testMsg.nyl1 || testMsg.pol1 || testMsg.acr1 || testMsg.wol1);
						break;
					case 'p3-2':
						result = testMsg.launderingTemp && testMsg.launderingStandard && (testMsg.colorChange2 || testMsg.ace2 || testMsg.cot2 || testMsg.nyl2 || testMsg.pol2 || testMsg.acr2 || testMsg.wol2);
						break;
					case 'p3-3':
						result = testMsg.waterStandard && (testMsg.colorChange3 || testMsg.ace3 || testMsg.cot3 || testMsg.nyl3 || testMsg.pol3 || testMsg.acr3 || testMsg.wol3);
						break;
					case 'p3-4':
						result = testMsg.perspirationStandard && (testMsg.colorChange4 || testMsg.ace4 || testMsg.cot4 || testMsg.nyl4 || testMsg.pol4 || testMsg.acr4 || testMsg.wol4);
						break;
					case 'p3-5':
						result = testMsg.perspirationStandard && (testMsg.colorChange5 || testMsg.ace5 || testMsg.cot5 || testMsg.nyl5 || testMsg.pol5 || testMsg.acr5 || testMsg.wol5);
						break;
					case 'p4':
						result = this.getTestShow('p4-1') || this.getTestShow('p4-2');
						break;
					case 'p4-1':
						result = testMsg.phStandard && testMsg.phValue;
						break;
					case 'p4-2':
						result = currentGoods.yarnType === '梭织布' && testMsg.pixStandard && (testMsg.pixWarp || testMsg.pixWeft);
						break;
					default:
						break;
				}
				return result;
			},
        }
    }
</script>

<style lang="scss" scoped>
    .report {
        display: flex;
        align-items: center;
        padding: 20px 0;
        .report_item {
            display: flex;
            align-items: center;
            width: 33%;
            height: 100%;
            .title {
                width: 10%;
                padding: 0 16px;
                display: flex;
                align-items: center;
                writing-mode: vertical-lr;
            }
            .content {
                width: 90%;
                .content_item {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    padding: 4px 0;
                    .content_item_left {
                        .name {
                            font-size: 16px;
                        }
                        .standard {
                            font-size: 10px;
                            color: #b4b4b4;
                        }
                    }
                    .content_item_right {
                        display: flex;
                        flex-wrap: wrap;
                        align-items: center;
                        .right_item {
                            display: flex;
                            flex-wrap: wrap;
                            align-items: center;
                            .label {
                                font-size: 10px;
                                color: #b4b4b4;
                            }
                            .value {
                                font-size: 14px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>